import { render, staticRenderFns } from "./dashboardLeads.vue?vue&type=template&id=7620c42a&scoped=true&"
import script from "./dashboardLeads.vue?vue&type=script&lang=js&"
export * from "./dashboardLeads.vue?vue&type=script&lang=js&"
import style0 from "./dashboardLeads.vue?vue&type=style&index=0&id=7620c42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620c42a",
  null
  
)

export default component.exports